module.exports = __webpack_public_path__ + "static/media/logo_ais.e4dba6ff.png";